import React from "react";
import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import {Page} from "./types";
import ScrollToTop from "./ScrollToTop";
import Footer from "shared/Footer/Footer";
import Page404 from "containers/Page404/Page404";

// import PageContact from "containers/PageContact/PageContact";
// import PageAbout from "containers/PageAbout/PageAbout";
import PageSignUp from "containers/PageSignUp/PageSignUp";
import PageLogin from "containers/PageLogin/PageLogin";
import SiteHeader from "containers/SiteHeader";
import FooterNav from "components/FooterNav";
import useWindowSize from "hooks/useWindowResize";

import EventDetailPage from "containers/EventDetailPage/EventDetailPage";
import {useAuth} from "contexts/AuthContext";
import ProfilePage from "containers/ProfilePage/ProfilePage";
import PageRecoverPassword from "containers/PageRecoverPassword/PageRecoverPassword";
import PageHome from "containers/PageHome/PageHome";
import PoliciesPage from "containers/Faq/PoliciesPage";
import TermsPage from "containers/Faq/TermsPage";

export const pages: Page[] = [
  {path: "/", component: PageHome},

  // {path: "/contact", component: PageContact},
  // {path: "/about", component: PageAbout},
  {path: "/signup", component: PageSignUp},
  {path: "/login", component: PageLogin},

  {path: "/policies", component: PoliciesPage},
  {path: "/terms", component: TermsPage},

  {path: "/detailEvent/:id", component: EventDetailPage},
  {path: "/profile", component: ProfilePage},
  {path: "/forgot-pass", component: PageRecoverPassword},
];

const MyRoutes = () => {
  let WIN_WIDTH = useWindowSize().width;
  if (typeof window !== "undefined") {
    WIN_WIDTH = WIN_WIDTH || window.innerWidth;
  }

  const {isLoggedIn} = useAuth();

  return (
    <BrowserRouter
      basename="/"
      future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true,
      }}
    >
      <ScrollToTop />
      <SiteHeader />

      <Routes>
        {pages.map(({component, path}) => {
          const Component = component;
          if (path === "/login") {
            return (
              <Route
                key={path}
                path={path}
                element={isLoggedIn ? <Navigate to="/" /> : <Component />}
              />
            );
          }
          if (path === "/signup") {
            return (
              <Route
                key={path}
                path={path}
                element={isLoggedIn ? <Navigate to="/" /> : <Component />}
              />
            );
          }
          if (path === "/profile") {
            return (
              <Route
                key={path}
                path={path}
                element={!isLoggedIn ? <Navigate to="/" /> : <Component />}
              />
            );
          }
          return <Route key={path} element={<Component />} path={path} />;
        })}
        <Route path="*" element={<Page404 />} />
      </Routes>

      {WIN_WIDTH < 768 && <FooterNav />}
      <Footer />
    </BrowserRouter>
  );
};

export default MyRoutes;
